module.exports = __webpack_public_path__ + "static/media/atlas-2.7dfd6ea0.png";